import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import MySideBar from '../common/MySideBar';

//Create Unit dependencies
import MyTooltip from '../common/MyTooltip';
import CreateUnitModel from './CreateUnitModel';
import ListUnits from './ListUnits';

import {
  CREATE_PROJECT_MODEL_ACTION_CREATE, 
  CREATE_PROJECT_MODEL_ACTION_EDIT,
  CREATE_PROJECT_MODEL_ACTION_SHOW,
  ROLE_ADMIN
} from '../common/redux/constantes';


export class DefaultPage extends Component {

  state = {
    openCreateUnitDialog:false,
    createUnitDialogAction:CREATE_PROJECT_MODEL_ACTION_CREATE,
    unitEdit:{}
  }


  static propTypes = 
  {
    unit: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };


  closeCreateUnitDialog = ()=>
  {
    this.setState({openCreateUnitDialog:false});
    this.list.wrappedInstance.refreshTable();
  }

  openCreateUnitDialog = ()=>{
    this.setState({
      openCreateUnitDialog:true, 
      createUnitDialogAction:CREATE_PROJECT_MODEL_ACTION_CREATE,
      unitEdit:{}
    });
  }

  editUnit = (unit)=>{
     this.setState({
      openCreateUnitDialog:true, 
      createUnitDialogAction:CREATE_PROJECT_MODEL_ACTION_EDIT,
      unitEdit:unit
    });
  }

  showUnit = (unit)=>{
     this.setState({
      openCreateUnitDialog:true, 
      createUnitDialogAction:CREATE_PROJECT_MODEL_ACTION_SHOW,
      unitEdit:unit
    });
  }

  render() {
    return (
      <div >
          <MySideBar>
            <ListUnits ref={instance => { this.list = instance; }} editUnit={this.editUnit} showUnit={this.showUnit}/>
            <CreateUnitModel 
              openDialog={this.state.openCreateUnitDialog} 
              closeDialog={this.closeCreateUnitDialog} 
              actionDialog={this.state.createUnitDialogAction}
              unitEdit={this.state.unitEdit}
            />
            {
              Number(localStorage.getItem("role")) === ROLE_ADMIN?
              (<MyTooltip openDialog={this.openCreateUnitDialog} />)
              :null
            }
        </MySideBar>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    unit: state.unit,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);



// WEBPACK FOOTER //
// ./src/features/unit/DefaultPage.js